/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Nodeuntitled1Inputs */

const zh_course_nodeuntitled1 = /** @type {(inputs: Course_Nodeuntitled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未命名节点`)
};

const en_course_nodeuntitled1 = /** @type {(inputs: Course_Nodeuntitled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled Node`)
};

const es_course_nodeuntitled1 = /** @type {(inputs: Course_Nodeuntitled1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nodo sin título`)
};

/**
* | output |
* | --- |
* | "Untitled Node" |
*
* @param {Course_Nodeuntitled1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_nodeuntitled1 = /** @type {((inputs?: Course_Nodeuntitled1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Nodeuntitled1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_nodeuntitled1(inputs)
	if (locale === "en") return en_course_nodeuntitled1(inputs)
	return es_course_nodeuntitled1(inputs)
});
export { course_nodeuntitled1 as "course_nodeUntitled" }